export class Stats {
  inProgress: number;
  inProgressLate: number;
  completedLate: number;
  likelyLate: number;
  startedToday: number;
  finishedToday: number;

  static fromDto(p: any): Stats {
    return new Stats(
      p.in_progress,
      p.in_progress_late,
      p.completed_late,
      p.likely_late,
      p.started_today,
      p.finished_today
    );
  }

  constructor(
    inProgress: number,
    inProgressLate: number,
    completedLate: number,
    likelyLate: number,
    startedToday: number,
    finishedToday: number) {
    this.inProgress = inProgress;
    this.inProgressLate = inProgressLate;
    this.completedLate = completedLate;
    this.likelyLate = likelyLate;
    this.startedToday = startedToday;
    this.finishedToday = finishedToday;
  }
}
